// SPDX-License-Identifier: AGPL-3.0-or-later

import {type ThemeType, ThemeTypes} from '@konvo/constants/src/UserConstants';

export type SupportedTheme = Exclude<
	ThemeType,
	typeof ThemeTypes.COAL | typeof ThemeTypes.DARK_LEGACY | typeof ThemeTypes.GLASS_LIGHT
>;

/** Keep older device/server preferences dark when retiring their palettes. */
export function normalizeTheme(theme: ThemeType): SupportedTheme {
	if (theme === ThemeTypes.COAL || theme === ThemeTypes.DARK_LEGACY) return ThemeTypes.DARK;
	// KONVO: light glass is the glass theme with its tone knob set to light, not a separate preference.
	if (theme === ThemeTypes.GLASS_LIGHT) return ThemeTypes.GLASS;
	return theme;
}

/** KONVO: light glass shares the glass panel CSS and the light palette, so it wears all three classes. */
export function getThemeClassNames(effectiveTheme: string): Array<string> {
	if (effectiveTheme === ThemeTypes.GLASS_LIGHT) {
		return ['theme-light', 'theme-glass', 'theme-glass_light'];
	}
	return [`theme-${effectiveTheme}`];
}

/** KONVO: true for the themes that paint light surfaces (plain light and light glass). */
export function isLightThemeId(theme: string): boolean {
	return theme === ThemeTypes.LIGHT || theme === ThemeTypes.GLASS_LIGHT;
}
